<div class="activation-dialog p-4">
  <h2 class="text-xl font-bold mb-4">Activation de votre compte</h2>

  <form [formGroup]="form" (ngSubmit)="submit()">

    <app-custom-input
      [parentForm]="form"
      controlName="lastName"
      label="Nom"
      placeholder="Entrez votre nom"
      [required]="true"
    ></app-custom-input>

    <app-custom-input
      [parentForm]="form"
      controlName="firstName"
      label="Prénom"
      placeholder="Entrez votre prénom"
      [required]="true"
    ></app-custom-input>

    <app-custom-input
      [parentForm]="form"
      controlName="email"
      label="Adresse e-mail"
      type="email"
      placeholder="exemple@domaine.com"
      [required]="true"
    ></app-custom-input>

    <app-custom-input
      [parentForm]="form"
      controlName="password"
      label="Mot de passe"
      type="password"
      positionIcon="right"
      [required]="true"
    ></app-custom-input>

    <div class="fs-11 my-2 text-secondary">
      <span [ngClass]="{ 'text-success': passwordFormField?.match('.{8,}') }">
        Le mot de passe doit contenir au moins 8 caractères
      </span>,
      <span [ngClass]="{ 'text-success': passwordFormField?.match('^(?=.*[A-Z])') }">
        une lettre majuscule
      </span>,
      <span [ngClass]="{ 'text-success': passwordFormField?.match('(?=.*[a-z])') }">
        une lettre minuscule
      </span>,
      <span [ngClass]="{ 'text-success': passwordFormField?.match('(?=.*\\d)') }">
        un chiffre
      </span>,
      <span [ngClass]="{ 'text-success': passwordFormField?.match('(?=.*[!@#$%^&*/])') }">
        un caractère spécial
      </span>.
    </div>

    <app-custom-input
      [parentForm]="form"
      controlName="confirmPassword"
      label="Confirmez le mot de passe"
      type="password"
      positionIcon="right"
      [required]="true"
    ></app-custom-input>

    <div class="text-center mt-4">
      <app-button
        text="Activer mon compte"
        label="Activer mon compte"
        type="submit"
        [disabled]="form.invalid"
      ></app-button>
    </div>
  </form>
</div>
